import { render, staticRenderFns } from "./my-machines-list-wrapper.vue?vue&type=template&id=bb32073e&"
var script = {}
import style0 from "./my-machines-list-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports